import React from 'react';

const Preloader = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-80 z-50 flex items-center justify-center">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 border-t-4 border-b-4 border-blue-500 rounded-full animate-spin"></div>
        <p className="mt-4 text-lg text-gray-600 font-medium">Loading... please wait.</p>
      </div>
    </div>
  );
};

export default Preloader;
